import { render } from "./WhiteNavbar.vue?vue&type=template&id=a889e15c&scoped=true"
const script = {}

import "./WhiteNavbar.vue?vue&type=style&index=0&id=a889e15c&scoped=true&lang=scss"

import exportComponent from "/Volumes/Quoicoubeh/Paraleclypse/website/paraleclypse/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a889e15c"]])

export default __exports__